import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  ArrowDownLeft,
  ArrowUpRight,
  Banknote,
  Building,
  Calendar,
  FileText,
  Printer,
  Download,
  Receipt,
  CheckCircle,
  RefreshCw,
  ArrowRightLeft,
} from "lucide-react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaWhatsapp,
  FaExchangeAlt,
  FaStickyNote,
  FaGlobe,
  FaCity,
  FaMapMarkerAlt,
  FaBuilding,
  FaLocationArrow,
  FaTruck,
  FaUserTie,
} from "react-icons/fa";
import axios from "axios";
import {
  Tooltip,
  TextField,
  Button,
  Snackbar,
  Alert,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
// import PDCOpenPopup from "./PDCOpenPopup";
// import PDCF2Popup from "./PDCF2Popup";
// import PDCIssuedPrint from "./PDCIssuedPrint";

const StockMovement = () => {
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "-";

  const newDate = new Date();
  const today = newDate.toISOString().split("T")[0];
  //   const [transferDate, setTransferDate] = useState(today);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [selectedItemType, setSelectedItemType] = useState("quantityMovement");

  const [group, setGroup] = useState("");
  const [subGroup, setSubGroup] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [location, setLocation] = useState("");

  const [groupList, setGroupList] = useState([]);
  const [subGroupList, setSubGroupList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [selectedMod, setSelectedMod] = useState("STOCKMOVEMENT");
  const [includeWZChecked, setIncludeWZChecked] = useState(false);
  const [stockMovementList, setStockMovementList] = useState([]);

  const handleTypeChange = (event) => {
    setSelectedItemType(event.target.value);
    const type = event.target.value;
    console.log("Selected Type:", type);

    if (type === "quantityMovement") {
      setSelectedMod("STOCKMOVEMENT");
    } else if (type === "slowMoving") {
      setSelectedMod("SLOWMOVING");
    } else if (type === "fastMoving") {
      setSelectedMod("FASTMOVING");
    } else if (type === "itemWiseAnalysis") {
      setSelectedMod("ITEMMOVING");
    } else if (type === "groupWise") {
      setSelectedMod("GRPMOVEMENT");
    } else if (type === "nonMoving") {
      setSelectedMod("NONMOVING");
    }
  };

  useEffect(() => {
    fetchCompanyInfo();
    fetchLocations();
    fetchMasterList("GROUP", setGroupList);
    fetchMasterList("SUBGROUP", setSubGroupList);
    fetchMasterList("CATEGORY", setCategoryList);
    fetchMasterList("SUBCATEGORY", setSubCategoryList);
    // fetchStockMovementList();
  }, []);

  useEffect(() => {
    console.log("selectedMod:", selectedMod);
  }, [selectedMod]);

  const fetchCompanyInfo = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    // let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${company_code_from_local_storage}/COMPANYINFO/-/-`;
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/COMPANYINFO/-/-`;

    try {
      const response = await axios.get(apiUrl);
      const data = response.data;
      const companyInfoData = data[0];
      console.log("companyInfoData :", companyInfoData);
      setFromDate(dayjs(companyInfoData.fystart).format("YYYY-MM-DD"));
      // setToDate(dayjs(companyInfoData.ftend).format("YYYY-MM-DD"))

      
    } catch (err) {
      console.error("Error while fetching companny Info", err);
    }
  };

  const fetchMasterList = async (type, setter) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    // let url = `${apiPaths[0]?.API_CONFIG}/api/MasterCount/${companyCode}/GROUP/-/-`;
    let url = `${apiPaths[0]?.API_CONFIG}/api/MasterCount/${COMPANY_CODE}/${type}/-/-`;

    try {
      const response = await axios.get(url);
      console.log("responseeee:", response.data);
      setter(response.data || []);
    } catch (err) {
      console.error("Error while loading Voucher Type List:", err);
    }
  };

  const fetchLocations = async () => {
    try {
      let department = localStorage.getItem("currentSelectedDepartment") || "-";
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;
      const apiURL = `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/LOCATONLIST_ALL/${department}/-`;
      const response = await axios.get(apiURL);
      const data = response.data;
      // console.log("Location List:", data);
      setLocationList(data);
    } catch (error) {
      console.error("Error while fetching location list!", error);
    }
  };

  // const wzValue =
  //   includeWZChecked &&
  //   ["FASTMOVING", "ITEMMOVING", "NONMOVING", "STOCKMOVEMENT"].includes(
  //     selectedMod
  //   )
  //     ? "C"
  //     : "-"
  //     ? "Y"
  //     : "N";

  let wzValue = "N";

  if (includeWZChecked) {
    if (
      ["FASTMOVING", "ITEMMOVING", "NONMOVING", "STOCKMOVEMENT"].includes(
        selectedMod,
      )
    ) {
      wzValue = "C";
    } else {
      wzValue = "Y";
    }
  }

  const fetchStockMovementList = async (startDate) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let url = `${
      apiPaths[0]?.API_CONFIG
    }/api/CRMStockLedger/${COMPANY_CODE}/${selectedMod}/-/-/${fromDate}/${toDate}/${
      group?.trim() ? group.trim() : "-"
    }/${subGroup?.trim() ? subGroup.trim() : "-"}/${
      category?.trim() ? category.trim() : "-"
    }/${subCategory?.trim() ? subCategory.trim() : "-"}/${
      location?.trim() ? location.trim() : "-"
    }/${wzValue}/N`;

    try {
      setLoading(true);
      const response = await axios.get(url);
      const data = response.data;

      console.log("response data in stock movement:", data);
      setStockMovementList(data || []);
    } catch (err) {
      console.error("Error while loading stock ledger:", err);
    } finally {
      setLoading(false);
    }
  };

  const tableHeaders = React.useMemo(() => {
    if (!stockMovementList || stockMovementList?.length === 0) return [];
    return Object.keys(stockMovementList[0]);
  }, [stockMovementList]);

  const handleIncludeWZChange = (e) => {
    setIncludeWZChecked(e.target.checked);
  };

  const handleExport = () => {
    if (!stockMovementList || stockMovementList.length === 0) {
      alert("No data to export");
      return;
    }

    const columns = tableHeaders.map((key) => ({
      field: key,
      headerName: key.replace(/_/g, " ").toUpperCase(),
    }));

    exportToCSV(columns, stockMovementList, "Stock_Movement_List");
  };

  const exportToCSV = (columns, exportData, exportFileName = "export") => {
    if (!columns || !exportData || exportData.length === 0) return;

    // Create header row
    const headerRow = columns.map((col) => col.headerName);

    // Create data rows
    const dataRows = exportData?.map((row) =>
      columns.map((col) => {
        let value = row[col.field] ?? "";

        // Special formatting for date
        if (col.field === "CHQDATE" && value) {
          value = dayjs(value).format("DD/MM/YYYY");
        }

        return `"${String(value).replace(/"/g, '""')}"`;
      }),
    );

    // Combine header + data
    const csvContent = [headerRow, ...dataRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${exportFileName}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="flex justify-center items-start">
      <div className="w-[25vw] h-[77vh]  bg-white shadow-md border-r border-gray-200 p-3 space-y-5">
        <div className="space-y-8">
          {/* Dr A/C */}

          <div className="flex">
            <FormControl className="flex items-center justify-between">
              {/* <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel> */}
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={selectedItemType}
                onChange={handleTypeChange}
              >
                <FormControlLabel
                  value="quantityMovement"
                  control={
                    <Radio
                      sx={{
                        fontSize: "6px",
                        color: "#BD1528",
                        "&.Mui-checked": {
                          color: "#BD1528",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 22,
                        },
                      }}
                    />
                  }
                  label={`Quantity Movement`}
                />
                <FormControlLabel
                  value="fastMoving"
                  control={
                    <Radio
                      sx={{
                        color: "#BD1528",
                        "&.Mui-checked": {
                          color: "#BD1528",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 22,
                        },
                      }}
                    />
                  }
                  label={`Fast Moving`}
                />
                <FormControlLabel
                  value="groupWise"
                  control={
                    <Radio
                      sx={{
                        color: "#BD1528",
                        "&.Mui-checked": {
                          color: "#BD1528",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 22,
                        },
                      }}
                    />
                  }
                  label={`Groupwise`}
                />
              </RadioGroup>
            </FormControl>

            <FormControl className="flex items-center justify-between">
              {/* <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel> */}
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={selectedItemType}
                onChange={handleTypeChange}
              >
                <FormControlLabel
                  value="slowMoving"
                  control={
                    <Radio
                      sx={{
                        color: "#BD1528",

                        "&.Mui-checked": {
                          color: "#BD1528",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 22,
                        },
                      }}
                    />
                  }
                  label={`Slow Moving`}
                />
                <FormControlLabel
                  value="itemWiseAnalysis"
                  control={
                    <Radio
                      sx={{
                        color: "#BD1528",
                        "&.Mui-checked": {
                          color: "#BD1528",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 22,
                        },
                      }}
                    />
                  }
                  label={`Itemwise Analysis`}
                />
                <FormControlLabel
                  value="nonMoving"
                  control={
                    <Radio
                      sx={{
                        color: "#BD1528",
                        fontFamily: "Manrope",
                        "&.Mui-checked": {
                          color: "#BD1528",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 22,
                        },
                      }}
                    />
                  }
                  label={`Non Moving`}
                />
              </RadioGroup>
            </FormControl>
          </div>

          {/* Cr A/C */}
          <div className="flex justify-center items-center gap-1 mt-4">
            <div className=" w-full">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                From Date
              </label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                   transition-all duration-200"
              />
            </div>

            <div className="w-full">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <Calendar className="w-4 h-4 mr-2 text-gray-600" />
                To Date
              </label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="w-full px-3 py-2.5 text-sm bg-gray-100  border-none  rounded-lg 
                   focus:ring-2 focus:ring-purple-500 focus:border-blue-500 
                   transition-all duration-200"
              />
            </div>
          </div>

          {/* Manage Opening PDC Button */}
          {/* <div className="py-2">
            <button
              onClick={() => setOpenPDC(true)}
              className="w-full flex items-center justify-center gap-2 
               bg-purple-500 
               text-white font-semibold py-2.5 px-4 
               rounded-xl shadow-md hover:shadow-lg 
               hover:from-purple-600 hover:to-purple-700
               active:scale-95 transition-all duration-200
               focus:outline-none focus:ring-2 focus:ring-purple-300 text-sm"
            >
              <CheckCircle className="w-5 h-5 text-white" />
              Manage Opening PDC
            </button>
          </div> */}

          <div className="flex-1">
            <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
              {/* <Building className="w-4 h-4 mr-2 text-gray-600" /> */}
              Location
            </label>
            <select
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                   placeholder-gray-400 transition-all duration-200"
            >
              <option value="">Select Location...</option>
              {locationList.map((item, index) => (
                <option key={index} value={item.loc_code}>
                  {item.DESC}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center ">
            <div className="flex items-center justify-center w-full">
              <label className="text-xs font-semibold mr-2">
                Qty Without Zero Qty
              </label>

              <input
                type="checkbox"
                className={`w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                checked={includeWZChecked}
                onChange={handleIncludeWZChange}
              />
            </div>
          </div>

          <div className="flex justify-left items-center gap-1 ">
            <div className="flex-1">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <Building className="w-4 h-4 mr-2 text-gray-600" />
                Group
              </label>
              <select
                value={group}
                onChange={(e) => setGroup(e.target.value)}
                className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                   placeholder-gray-400 transition-all duration-200"
              >
                <option value="">Select Group...</option>
                {groupList?.map((group, index) => (
                  <option key={index} value={group["GRP CODE"]}>
                    {group.DESCRIPTION}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex-1">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <Building className="w-4 h-4 mr-2 text-gray-600" />
                Sub Group
              </label>
              <select
                value={subGroup}
                onChange={(e) => setSubGroup(e.target.value)}
                className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                   placeholder-gray-400 transition-all duration-200"
              >
                <option value="">Select Sub Group...</option>
                {subGroupList?.map((group, index) => (
                  <option key={index} value={group["GRP CODE"]}>
                    {group.DESCRIPTION}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex justify-left items-center gap-1 ">
            <div className="flex-1">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <Building className="w-4 h-4 mr-2 text-gray-600" />
                Category
              </label>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                   placeholder-gray-400 transition-all duration-200"
              >
                <option value="">Select Category...</option>
                {categoryList?.map((group, index) => (
                  <option key={index} value={group["GRP CODE"]}>
                    {group.DESCRIPTION}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex-1">
              <label className="flex items-center text-xs font-semibold text-gray-700 mb-1.5">
                <Building className="w-4 h-4 mr-2 text-gray-600" />
                Sub Category
              </label>
              <select
                value={subCategory}
                onChange={(e) => setSubCategory(e.target.value)}
                className="w-full px-3 py-2.5 text-[0.75em] bg-gray-100 border-none rounded-lg 
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                   placeholder-gray-400 transition-all duration-200"
              >
                <option value="">Select Sub Category...</option>
                {subCategoryList?.map((group, index) => (
                  <option key={index} value={group["GRP CODE"]}>
                    {group.DESCRIPTION}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Action Buttons: Print & Export */}
          <div className="flex flex-col gap-3 py-2">
            <div className="flex justify-between items-center gap-4">
              <button
                onClick={fetchStockMovementList}
                className="flex-1 flex items-center justify-center gap-2 
               bg-indigo-500 text-white 
               font-medium px-4 py-2.5 rounded-lg shadow hover:shadow-md 
               transform hover:scale-[1.02] active:scale-100 
               transition-all duration-200 text-sm"
              >
                <RefreshCw className="w-4 h-4" />
                Apply
              </button>
              {/* <button
                // onClick={() => setIsPDCIssuedPrint(true)}
                className="flex-1 flex items-center justify-center gap-2 
                         bg-teal-500 text-white  
                         font-medium px-4 py-2.5 rounded-lg shadow hover:shadow-md 
                         transform hover:scale-[1.02] active:scale-100 
                         transition-all duration-200 text-sm"
              >
                <Printer className="w-4 h-4" />
                Print
              </button> */}
              <button
                onClick={handleExport}
                className="flex-1 flex items-center justify-center gap-2 
                                     bg-cyan-600 text-white 
                                     font-medium px-4 py-2.5 rounded-lg shadow hover:shadow-md 
                                     transform hover:scale-[1.02] active:scale-100 
                                     transition-all duration-200 text-sm"
              >
                <Download className="w-4 h-4" />
                Export
              </button>
            </div>
          </div>
        </div>
      </div>

      
      <div className="w-[72vw] h-[77vh] shadow-md scrollbar-auto-hide relative">
        {/* LOADER */}
        {loading && (
          <div className="absolute inset-0 z-20 flex items-center justify-center bg-white/60 backdrop-blur-sm">
            <div className="flex flex-col items-center gap-2">
              <div className="h-10 w-10 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
              <span className="text-xs text-gray-600 font-medium">
                Loading stock Movement...
              </span>
            </div>
          </div>
        )}

        {/* NO DATA */}
        {!loading && stockMovementList.length === 0 && (
          <div className="flex items-center justify-center h-full text-gray-500 text-sm">
            No data found for Stock Movement
          </div>
        )}

        {/* TABLE */}
        {!loading && stockMovementList.length > 0 && (
          <div className="overflow-auto h-full scrollbar-auto-hide ">
            <table className="relative text-xs border-collapse ">
              {/* AFTER */}
<thead className="bg-gray-100 sticky top-0 z-10">
  <tr>
    {tableHeaders.map((header) => {
      const isDesc = header.toUpperCase().includes("DESC");
      return (
        <th
          key={header}
          className={`bg-gray-100 font-normal border px-2 py-1 text-left ${
            isDesc ? "w-64 max-w-[250px] whitespace-normal" : "whitespace-nowrap"
          }`}
        >
          {header.toUpperCase()}
        </th>
      );
    })}
  </tr>
</thead>
<tbody>
  {stockMovementList.map((row, rowIndex) => (
    <tr key={rowIndex} className="hover:bg-indigo-50">
      {tableHeaders.map((header) => {
        const isDesc = header.toUpperCase().includes("DESC");

        return (
          <td
            key={header}
            className={`border px-2 py-1 text-left ${
              isDesc
                ? "w-64 max-w-[250px] whitespace-normal break-words"
                : "whitespace-nowrap"
            }`}
          >
            {row[header] ?? "-"}
          </td>
        );
      })}
    </tr>
  ))}
</tbody>
            </table>
          </div>
        )}
      </div>
      {/* {openPDC && <PDCOpenPopup setOpenPDC={setOpenPDC} data={"12040036"} />}
      {pdcDrModalOpen && <PDCF2Popup setPdcDrModalOpen={setPdcDrModalOpen}  accounts={accountsF2}/>} */}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>

      {/* {isPDCIssuedPrint && (
        <div className="m-6">
          <PDCIssuedPrint
            pdcIssuedPrintDataFromAPI={pdcIssuedList}
            setIsPDCIssuedPrint={setIsPDCIssuedPrint}
            isPDCIssuedPrint={isPDCIssuedPrint}
          />
        </div>
      )} */}
    </div>
  );
};

export default StockMovement;
